export class PasswordSettings {
	passwordRotationInDays = 30;

	constructor(init?: Partial<PasswordSettings>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
